const defaultState = {
	searchMonth: '',
	startDt: '',
	endDt: '',
	plants: [],
	plant: '',
	logTypes: [],
	logType: '',
	procId: '',
	message: '',
	chkFlag: '',
	resultList: [],
	groups: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
